import HeatMapGrid from "react-heatmap-grid";
import React, {useEffect } from "react";


const generateHeatmapData = (sensors) => {
    // Group sensors by rows and map their values
      if (!sensors || sensors.length === 0) {
    return { xLabels: [], yLabels: [""], data: [] };
  }

  const xLabels = sensors.map(sensor => sensor.Name);
  const yLabels = [""];


   const data=[
        sensors.map((sensor) => ({
          value: sensor.Value,
          status: sensor.Status,
          id: sensor.Id,
          unit: sensor.Meta.Units
        }))
      ]

  return { xLabels, yLabels, data };
};

//Just an example of colour based of temp
export const getTemperatureColour = (value, unit) => {
  // Convert Fahrenheit to Celsius if necessary
  if (unit === "°F") {
    value = (value - 32) * 5 / 9; // Convert to Celsius
  }

  return getColorForValue(value);
};

function getColorForValue(value) {
  const stops = [
    { value: -40, color: [0, 0, 255] },   // extreme cold - deep blue
    { value: 0,   color: [0, 128, 255] }, // cold - blue
    { value: 30,  color: [0, 255, 0] },   // mild - green
    { value: 50,  color: [255, 255, 0] }, // warm - yellow
    { value: 60,  color: [255, 191, 0] }, // hot - amber
    { value: 70,  color: [255, 0, 0] },   // very hot - red
    { value: 100, color: [139, 0, 0] },   // extreme heat - dark red
  ];

  if (value <= stops[0].value) {
    return `rgb(${stops[0].color.join(', ')})`;
  }
  if (value >= stops[stops.length - 1].value) {
    return `rgb(${stops[stops.length - 1].color.join(', ')})`;
  }

  for (let i = 0; i < stops.length - 1; i++) {
    const a = stops[i];
    const b = stops[i + 1];
    if (value >= a.value && value <= b.value) {
      const t = (value - a.value) / (b.value - a.value);
      const r = Math.round(a.color[0] + t * (b.color[0] - a.color[0]));
      const g = Math.round(a.color[1] + t * (b.color[1] - a.color[1]));
      const bl = Math.round(a.color[2] + t * (b.color[2] - a.color[2]));
      return `rgb(${r}, ${g}, ${bl})`;
    }
  }
}


// Shared with RollerDiagram so a sensor's dot and its heatmap cell always
// agree on colour: a WARNING status always wins over the temperature
// gradient, regardless of the actual reading.
export const resolveSensorColor = (value, status, unit) => (
    status === "WARNING" ||  status === "Alarm" ? "rgb(255, 0, 0)" : getTemperatureColour(value, unit)
);

const getTextColor = (backgroundColor) => {
  const [r, g, b] = backgroundColor
    .match(/\d+/g)
    .map(Number);

  const brightness = (r * 299 + g * 587 + b * 114) / 1000;

  return brightness > 125 ? "black" : "white";
};

const SensorHeatmap = ({ groupId, sensors,onSensorClick,selectedSensors  }) => {

    const { xLabels, yLabels, data } = generateHeatmapData(sensors);
      const safeSelectedSensors = Array.isArray(selectedSensors) ? selectedSensors : [];


        const xLabelsVisibility = new Array(xLabels.length).fill(false);
    return (
        <div style={{width: "100%", fontSize: "12px"}}>


            <HeatMapGrid
                xLabels={xLabels}
                xLabelsVisibility={xLabelsVisibility}
                yLabels={[""]}
                yLabelWidth={0}
                displayYLabels={false}
                data={data}
                cellStyle={(background, {value, status, id,unit}) => {
                    const bgColor = resolveSensorColor(value, status, unit);
                    const textColor = getTextColor(bgColor);
                    const isSelected = safeSelectedSensors.some((sensor) => sensor.Id === id);
              if (status === "WARNING") {
                            return {
                                background: "rgb(255, 0, 0)",
                                color: "white",
                                fontSize: "13px",
                                fontWeight: "bold",
                                 borderRadius: '4px', // Softened corners
                                border: isSelected ? "2px solid #A9CC13" : "none", // Highlight is border
                                boxShadow: isSelected ? "inset 0 0 10px rgba(0, 123, 255, 0.5), 0 2px 5px rgba(0, 0, 0, 0.2)" : "0 1px 3px rgba(0, 0, 0, 0.1)",
                                   transition: "all 0.3s ease-in-out",
                            };
                        }

                        if (status === "Alarm") {
                            return {
                                background: "rgb(255, 0, 0)",
                                color: "white",
                                fontSize: "13px",
                                fontWeight: "bold",
                                 borderRadius: '4px', // Softened corners
                                border: isSelected ? "2px solid #A9CC13" : "none", // Highlight is border
                                boxShadow: isSelected ? "inset 0 0 10px rgba(0, 123, 255, 0.5), 0 2px 5px rgba(0, 0, 0, 0.2)" : "0 1px 3px rgba(0, 0, 0, 0.1)",
                                   transition: "all 0.3s ease-in-out",
                            };
                        }


                    return {
                        background: bgColor,
                        color: textColor,
                        fontSize: "12px",
                        cursor: "pointer",
                        border: isSelected ? "2px solid #000" : "1px solid #ccc",
                        boxShadow: isSelected ? "0 4px 8px rgba(0, 0, 0, 0.2)" : "none",
                        transform: isSelected ? "scale(1.05)" : "scale(1)",
                        transition: "all 0.2s ease-in-out",
                    };
                }}
                cellRender={({value, status,unit}) => (
                    status === "Alarm" ? (
                        <div title="FAULT">FAULT</div>
                    ) : (
                        <div  title={`Value: ${value}`}>
                             {value}
                            {unit=== "C" ? <span>&deg;C</span> : unit}

                            {status === "WARNING" && " ⚠"}
                        </div>
                    )
                )}
                onClick={(x, y) => {
                    const clickedSensor = data[y][x];
                    onSensorClick(groupId,clickedSensor.id);
                }}
            />
        </div>

    );
};

export default SensorHeatmap;